import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

const paramsSchema = z.object({
  staffId: z.string(),
})

export const Route = createFileRoute('/_authenticated/_organization/staff/$staffId/')({
  params: paramsSchema,
  beforeLoad: ({ params }) => {
    // Redirect to overview tab by default
    throw redirect({
      to: '/staff/$staffId/overview',
      params: { staffId: params.staffId },
    })
  },
})

